import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

const WEB_COMPONENT_SCRIPT_ID = 'rc-web-components';
@Injectable({
  providedIn: 'root',
})
export class WebComponentsLoaderService {
  public loadDefaultComponents() {
    this.loadScript(environment.webComponents?.location);
  }

  private loadScript(location: string) {
    if (!location || !document || document.getElementById(WEB_COMPONENT_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = WEB_COMPONENT_SCRIPT_ID;
    script.src = location;
    script.type = 'module';
    document.body.append(script);
  }
}
